import _ from 'lodash'
import enabled from '../../helpers/enabled'
import values from '../../helpers/values'

export default (form, year) => {
  if (year !== 0) return 0

  return _.sum(values(enabled(form, 'oneTimeCosts')))
}
